import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  divider: {
    borderLeft: 0,
    borderRight: 0,
    borderTop: [
      theme.get('divider', 'border.width'),
      theme.get('divider', 'border.style'),
      theme.getColor('divider', 'basic', 'border')
    ],
    borderBottom: 0,

    width: '100%'
  }
}));

const useVariantStyles = createUseStyles((theme) => ({}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStyles
      }
    };

    static propTypes = {
      variant: PropTypes.string
    };

    static defaultProps = {};

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { classes, children, variant, ...props } = this.props;

      const mergedClassName = mergeClassName(
        classes.main.divider,
        variant && classes.variant[variant]
      );

      return (
        <div {...props} className={mergedClassName}>
          {children}
        </div>
      );
    }
  }
);
